import { Region } from '../interfaces/Region'

export const regionUK = 'uk' as const
export const regionUS = 'us' as const
export const regionDE = 'de' as const

export const regionOptions = [
	{
		label: 'United Kingdom',
		value: regionUK
	},
	{
		label: 'United States',
		value: regionUS
	},
	{
		label: 'Germany',
		value: regionDE
	}
] as const

const regionTokenSuffixByRegion: Record<Region, string> = {
	[regionUK]: 'r1',
	[regionDE]: 'r2',
	[regionUS]: 'r3'
}
const legacyRegionTokenSuffixByRegion: Record<Region, string> = {
	[regionUK]: regionUK,
	[regionDE]: regionDE,
	[regionUS]: regionUS
}

export const getRegionTokenSuffix = (region: Region): string => regionTokenSuffixByRegion[region]
export const getMockedRegionToken = (regionTokenSuffix: string): string => `mockedToken@${regionTokenSuffix}`
export const parseRegionTokenSuffix = (value: string): Region | null => {
	const region = regionOptions.find((option) => regionTokenSuffixByRegion[option.value] === value || legacyRegionTokenSuffixByRegion[option.value] === value)

	return region?.value ?? null
}

// regions that are disabled for the given environment
export const envRegionsDisabled: { [key in Region]: string[] } = {
	[regionUK]: [],
	[regionUS]: ['local', 'nightly', 'beta'],
	[regionDE]: []
}
